import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { User } from './user';
export { User };
import { userSchema } from '@schemas/business-objects/user';
import { CandidateFormGroup } from './candidate-form-group';
import { CorrespondenceItemFormArray } from './correspondence-item-form-group';
import { InterviewFormArray } from './interview-form-group';
import { MyUserTaskFormArray } from './my-user-task-form-group';
import { RoleAssignmentFormArray } from './role-assignment-form-group';
import { TrainingClassFormArray } from './training-class-form-group';
import { UserTaskFormArray } from './user-task-form-group';

export class UserFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    email: SchemaFormControl;
    firstName: SchemaFormControl;
    lastName: SchemaFormControl;
    phone: SchemaFormControl;
    roleAssignments: RoleAssignmentFormArray;
    userTasks: UserTaskFormArray;
    myUserTasks: MyUserTaskFormArray;
    candidate: CandidateFormGroup;
    trainingClasses: TrainingClassFormArray;
    interviews: InterviewFormArray;
    sentCorrespondenceItems: CorrespondenceItemFormArray;
    receivedCorrespondenceItems: CorrespondenceItemFormArray;
  };

  declare value: Partial<User>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(userSchema, User, data, options);
  }

  get object(): User {
    return new User(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'roleAssignments':
        return new RoleAssignmentFormArray();
      case 'userTasks':
        return new UserTaskFormArray();
      case 'myUserTasks':
        return new MyUserTaskFormArray();
      case 'candidate':
        return new CandidateFormGroup();
      case 'trainingClasses':
        return new TrainingClassFormArray();
      case 'interviews':
        return new InterviewFormArray();
      case 'sentCorrespondenceItems':
        return new CorrespondenceItemFormArray();
      case 'receivedCorrespondenceItems':
        return new CorrespondenceItemFormArray();
      default:
        return undefined;
    }
  }
}

export class UserFormArray extends PersistedFormArray {
  readonly entityName = 'User' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(userSchema, User, options);
  }

  protected override createItemGroup() {
    return new UserFormGroup();
  }

  get array(): User[] {
    return this.controls.map((group: UserFormGroup) => group.object);
  }
}

export class UserPersistedArray extends PersistedArray<User> {
  readonly entityName = 'User' as const;

  constructor(options?: PersistedArrayOptions) {
    super(User, options);
  }
}
